"use client";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import React from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";

const GetInstantQuoteButton = ({ className, text }: { text?: React.ReactNode; className?: string }) => {
	const t = useTranslations();

	return (
		<div className={`flex justify-center ${className}`}>
			<Link href="/upload">
				<Button
					size="large"
					type="primary"
					shape="round"
					className="group border !bg-mainColor !font-semibold text-white hover:!text-black"
				>
					{text || t("base.getInstantQuote")}
					<ArrowRightOutlined className="transform transition-all duration-700 group-hover:translate-x-2" />
				</Button>
			</Link>
		</div>
	);
};

export default GetInstantQuoteButton;
